import React, { useEffect } from 'react';
import styles from '../styles/pages/_TicketPage.module.scss';
import SEO from '../components/SEO';

const TicketPage = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://s3-eu-west-1.amazonaws.com/xceed-widget/2019-version/dist/loader.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <main className={styles.ticketPage}>
      <SEO
        title="Billetterie"
        description="Bienvenue au Poney Festival - Le festival qui vous fera vibrer"
        url="/ticket/"  // Ajout du slash final
      />
      <section className={styles.titleSection}>
        <h1 className={styles.ticket__title}>Billetterie</h1>
      </section>
      <div id="xceed-widget"></div>
    </main>
  );
};

export default TicketPage;